import React from "react";

const Reload = ({className}) => {
  return <button className={`header__refresh ${className}`}>⟳</button>;
};

export default Reload;
